import React from 'react';
import './less/payment.less';
import { Card, Descriptions, Badge, Table } from 'antd';

const Payment = () => {

    const columns = [
        {
            title: 'عنوان',
            dataIndex: 'title',
            key:0
        },
        {
            title: 'قیمت پایه',
            dataIndex: 'price',
            key:1
        },
        {
            title: 'مدت زمان دوره',
            dataIndex: 'time',
            key:2
        },
        {
            title: 'تخفیف',
            dataIndex: 'off',
            key:3
        },
        {
            title: 'مجموع',
            dataIndex: 'sum',
            key:4
        },
    ];

    const data = [
        {
            key:0,
            title: 'سرویس ۵ کاربره',
            price: '550,000 تومان',
            time: '3 ماه',
            off: '495,000 تومان',
            sum: '78,000 تومان',
        },
        {
            key:1,
            title: 'بسته دامنه اختصاصی',
            price: '100,000 تومان',
            time: '3 ماه',
            off: '495,000 تومان',
            sum: '300,000 تومان',
        },
        {
            key:2,
            title: 'بسته شخصی‌سازی',
            price: '200,000 تومان',
            time: '3 ماه',
            off: '495,000 تومان',
            sum: '600,000 تومان',
        },
    ];


    return (
        <Card title="تایید و پرداخت">
            <Descriptions title="مشخصات سفارش" bordered>
                <Descriptions.Item span={3} label="تعداد کاربر همزان">
                    400 نفر

                </Descriptions.Item>
                <Descriptions.Item span={3} label="تعداد ساعت در ماه">
                    نامحدود
                </Descriptions.Item>
                <Descriptions.Item span={3} label="تعداد ویدئو همزمان">
                    3 ویدئو

                </Descriptions.Item>
                <Descriptions.Item span={3} label="دوره سرویس">
                    1 ماهه

                </Descriptions.Item>
                <Descriptions.Item span={3} label="دوره سرویس">
                    نامحدود

                </Descriptions.Item>
                <Descriptions.Item label="بسته‌ها" span={3}>
                    <Badge status="processing" text="دامنه اختصاصی – 3 ماهه + 10 روز هدیه" />
                    <br />
                    <Badge status="processing" text="شخصی‌سازی – 3 ماهه + 10 روز هدیه" />
                </Descriptions.Item>
            </Descriptions>

            <h4 className="box-title">هزینه ها</h4>
            <Table columns={columns} bordered={true} pagination={false} dataSource={data} size="middle" />


            <Descriptions title="" bordered>
                <Descriptions.Item span={3} label="جمع کل">
                    3,825,000تومان
                </Descriptions.Item>
                <Descriptions.Item span={3} label="مالیات">
                    344,250 تومان (۹٪)
                </Descriptions.Item>
                <Descriptions.Item span={3} label="مبلغ قابل پرداخت">
                    4,169,250 تومان
                </Descriptions.Item>
            </Descriptions>
        </Card>

    )
}
export default Payment;